import { getAuthorizationHeaders } from "../util/request";
import { apiBaseUrl } from "./apiBaseUrl";
export class RecommendationsApi {
    constructor(customerId, recommendationId) {
        this.baseUrl = `${apiBaseUrl}/customers/${customerId}/recommendations/${recommendationId}`;
    }
    async getRecommendation(isPreview, allowDeleted) {
        const url = new URL(this.baseUrl);
        if (isPreview) {
            url.searchParams.set("preview", "true");
        }
        if (allowDeleted) {
            url.searchParams.set("allowDeleted", "true");
        }
        const headers = await getAuthorizationHeaders({
            method: "GET",
            url: url.href,
        });
        const response = await fetch(url.href, { headers });
        if (!response.ok) {
            throw new Error();
        }
        const responseBody = await response.json();
        return responseBody;
    }
}
